import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = ({ children, className, css }) => (
  <div className="cr-layout__wrapper">
    <div className={`${className} cr-max-width-content`} css={css}>
      {children}
    </div>
  </div>
);

Wrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  css: PropTypes.shape(),
};

export default Wrapper;
